import React, { useState } from 'react'
import "../clients/clients.scss"
import "./admin.scss"
import { toast } from 'react-toastify'
import api from 'api'
import { useDispatch } from 'react-redux'
import { actions } from 'redux/reducers'
import { useHistory } from 'react-router-dom'

function Admin() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [contactEmail, setContactEmail] = useState<string>("")

    const actAsUser = async () => {
        if (!isValidEmail(contactEmail)) {
            toast.warning("Please enter a valid email address!")
            setContactEmail("")
            return;
        }
        var contact = await api.user.getIdByEmail(contactEmail);

        if (null != contact.Id) {
            var loginResponse = await api.user.loginWithId(contact.Id);
            if (loginResponse.access_token !== null) {
                localStorage.AccessToken = loginResponse.access_token;
                await api.user.get().then((data) => dispatch(actions.user.set(data)));
                history.replace('/');
            } else {
                toast.warning("Could not login")
            }
            console.log(loginResponse, "HALLO")
        } else {
            toast.warning("User not found")
        }

    }

    function isValidEmail(email: string) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    return (
        <div className='clients options-container' id='admin'>
            <div id="top">
                Admin
            </div>
            <form>
                <div className="input-group">
                    <label>Act as contact email</label>
                    <div className='button-split'>
                        <div className='my-button' onClick={actAsUser}><i className="fa-solid fa-right-to-bracket"></i></div>
                        <input type={"text"} value={contactEmail} onChange={(e) => setContactEmail(e.currentTarget.value)} placeholder={"Contact email address"} />
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Admin